import React from 'react';
import { LegacySeoCrawlLinks } from './home/LegacySeoCrawlLinks';
import { SITE_IMAGES } from '../components/siteImages';
import { HomeHeroInfo } from './home/HomeHeroInfo';
import { HomeHeroForm } from './home/HomeHeroForm';
import { HomeVideoPlayer } from './home/HomeVideoPlayer';
import { HomeVideoContent } from './home/HomeVideoContent';
import { HomePrograms } from './home/HomePrograms';
import { HomeBenefits } from './home/HomeBenefits';
import { HomeGetStarted } from './home/HomeGetStarted';
import { HomeKarateVsTaekwondo } from './home/HomeKarateVsTaekwondo';
import { HomeReviews } from './home/HomeReviews';
import { HomeScheduleLocation } from './home/HomeScheduleLocation';
import { HomeFAQHeader } from './home/HomeFAQHeader';
import { HomeFAQQuestions } from './home/HomeFAQQuestions';
import { HomeFAQActions } from './home/HomeFAQActions';
import { HomeFinalCTA } from './home/HomeFinalCTA';
export function Home() {
  return <div className="flex flex-col" data-id="element-1613">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1614">
        <div className="absolute inset-0 opacity-70" data-id="element-1615">
          <img src={SITE_IMAGES.heroHome} alt="Storm Taekwondo team holding medals" className="block w-full h-full object-cover" data-id="element-1616" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-ink/20" data-id="element-1617" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1618">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-1619">
            <HomeHeroInfo data-id="element-1620" />

            <div className="lg:pl-10 hidden md:block" data-id="element-1621">
              <HomeHeroForm data-id="element-1622" />
            </div>
          </div>
        </div>
      </section>
      <section className="relative py-16 lg:py-20 bg-ink overflow-hidden" data-id="element-1623">
        {/* Subtle red accent stripe */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-1624" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1625">
          <div className="grid lg:grid-cols-5 gap-10 items-center" data-id="element-1626">
            {/* Left: video */}
            <div className="lg:col-span-3" data-id="element-1627">
              <HomeVideoPlayer data-id="element-1628" />
            </div>

            {/* Right: copy + CTAs */}
            <div className="lg:col-span-2" data-id="element-1629">
              <HomeVideoContent data-id="element-1630" />
            </div>
          </div>
        </div>
      </section>
      <HomePrograms data-id="element-1631" />
      <HomeBenefits data-id="element-1632" />
      <HomeGetStarted data-id="element-1633" />
      <HomeKarateVsTaekwondo data-id="element-1634" />
      <HomeReviews data-id="element-1635" />
      <HomeScheduleLocation data-id="element-1636" />
      <section className="py-24 bg-off-white" data-id="element-1637">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1638">
          <HomeFAQHeader data-id="element-1639" />
          <HomeFAQQuestions data-id="element-1640" />
          <HomeFAQActions data-id="element-1641" />
        </div>
      </section>
      <HomeFinalCTA data-id="element-1642" />
      <LegacySeoCrawlLinks data-id="element-1643" />
    </div>;
}